import axios from '@/assets/js/axios.js'
import { BUTTONS_SERVICE_API } from './apis'
// 获取按钮列表
export function btnsList (params) {
  return axios({
    url: BUTTONS_SERVICE_API.LIST,
    method: 'post',
    data: params
  })
}
// 添加按钮
export function addBtns (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_HANDLE,
    method: 'post',
    data: params
  })
}
// 修改按钮信息
export function editBtns (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_HANDLE,
    method: 'put',
    data: params
  })
}
// 查看按钮信息
export function getBtns (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_HANDLE + '/' + params,
    method: 'get'
  })
}
// 删除按钮信息
export function deleteBtns (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_HANDLE + '/' + params,
    method: 'DELETE'
  })
}
// 分配权限
export function bindAccess (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_BIND_ACCESS,
    method: 'post',
    data: params
  })
}
// 根据菜单获取关联的按钮ID  按钮回显
export function listByMenuId (params) {
  return axios({
    url: BUTTONS_SERVICE_API.BUTTON_LIST_BY_MENU_ID,
    method: 'get',
    params: params
  })
}
